import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";
import moment from "moment";
import axios from "axios";
import HtmlParser from "react-html-parser";

const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.substr(0, text.lastIndexOf(" ", maxLength)) + "...";
};

const Latestblog = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [userData, setUserData] = useState([]);
  const getGitHubUserWithAxios = async () => {
    setIsLoaded(true);
    try {
      let url =
        "https://www.tekrevol.com/blogs/wp-json/wp/v2/posts?_embed&per_page=3&orderby=id&order=desc";
      if (props.id) {
        url += `&categories=${props.id}`;
      }
      const response = await axios.get(url);
      // const response = await axios.get(
      //   `https://www.tekrevol.com/blogs/wp-json/wp/v2/posts?_embed&per_page=3&categories=${props.id}&orderby=id&order=desc`
      // );
      setUserData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoaded(false);
    }
  };
  useEffect(() => {
    getGitHubUserWithAxios();
  }, []);

  return (
    <div className="latestblog_usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>Our Latest Blog Posts</h2>
          </Col>
        </Row>
        <Row className="h-100 blog-padd">
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="main_blogs">
              {userData.map((value, i) => (
                <div className="latest-blogbox" key={i}>
                  <div className="blog-img">
                    {value._embedded && value._embedded["wp:featuredmedia"] && (
                      <LazyLoadImage
                        src={value._embedded["wp:featuredmedia"][0].source_url}
                        effect="blur"
                        alt={value._embedded["wp:featuredmedia"][0].alt_text}
                        className="img-fluid"
                      />
                    )}
                  </div>
                  <div className="blog-contentusa">
                    <div className="orange_date"></div>
                    <Link href={`/blogs/${value.slug}`}>
                      <h5>{HtmlParser(value.title.rendered)}</h5>
                    </Link>
                    {HtmlParser(truncateText(value.excerpt.rendered, 150))}
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
        <div className="blog-btn">
          <Link
            href="/blogs/"
            className="border_btn dark_btn"
            aria-label="TekRevol Contact"
          >
            View All
          </Link>
        </div>
      </Container>
    </div>
  );
};

export default Latestblog;
